export default __webpack_public_path__ + "static/anthem-066b36602b13a4a4df8007817d161b59.svg";